import FormTabCheck from "../../assets/svg/FormTabCheck";

export default function ApprovalTabs({
  orderId,
  handleTabClick,
  selectedTab,
  testTypeId,
  orders,
  index,
  selectedIds,
  handleCheckboxChange,
}: any) {
  let tabs = [
    { id: "select-test", label: "Select Test" },
    { id: "patient-info", label: "Patient Information" },
    { id: "billing-info-medicare", label: "Billing Information" },
    { id: "guarantor-info", label: "Guarantor Information" },
    { id: "clinical-info", label: "Clinical Information" },
    { id: "additional-info", label: "Additional Information" },
    { id: "shipment-info", label: "Shipment Information" },
    { id: "laboratory-info", label: "Laboratory Information" },
    { id: "supporting-doc", label: "Supporting Documents" },
  ];

  // Filter out guarantor-info for test types other than 9 (AdvanceAD)
  if (testTypeId !== 9) {
    tabs = tabs.filter((tab) => tab.id !== "guarantor-info");
  }

  if (testTypeId === 1) {
    tabs = tabs.filter((tab) => tab.id !== "clinical-info");
  } else if (testTypeId === 8) {
    tabs = tabs.map((tab) => {
      if (tab.id === "clinical-info") {
        return { ...tab, label: "Patient Healthcare Information" };
      } else if (tab.id === "laboratory-info") {
        return { ...tab, label: "Specimen Information" };
      } else {
        return tab;
      }
    });
  }

  const isChecked = selectedIds?.includes(orderId);

  return (
    <div className="top-0 sticky overflow-auto bg-sideNavGray px-2 pl-3 border-b py-4 w-full min-w-0 flex flex-col items-stretch">
      <div className="flex flex-col min-w-0">
        <div className="order-section min-w-0">
          <div className="tab-section min-w-0">
            <label
              htmlFor="additionalClinician"
              className="checkboxContainer flex items-center gap-2 font-semibold text-activeLink text-sm min-w-0 cursor-pointer"
              onClick={() => handleCheckboxChange(orderId)}
            >
              <input
                type="checkbox"
                name="additionalClinician"
                checked={isChecked}
                className="mr-0 shrink-0"
              />
              <span className="checkmark shrink-0" />
              <p className="truncate min-w-0 max-w-full">{`${index + 1}.${orders[index]?.header?.patientName} - ${orders[index]?.header?.test}`}</p>
            </label>
          </div>
          {tabs.map((tab) => (
            <div key={tab.id} className="tab-section ml-4 flex items-center">
              <div className={`w-[15%]`}>
                <FormTabCheck
                  className=" !text-xl"
                  fill={"#18B5B7"}
                  isvalid={"white"}
                  stroke={"#18B5B7"}
                />
              </div>
              <div
                className={`my-1 w-[95%] text-primary font-semibold capitalize cursor-pointer text-sm  hover:!text-activeLink`}
                onClick={() => handleTabClick(orderId, tab.id)}
              >
                {tab.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
